import { render } from "./PageTopImage.vue?vue&type=template&id=6a0358a8&scoped=true"
import script from "./PageTopImage.vue?vue&type=script&lang=js"
export * from "./PageTopImage.vue?vue&type=script&lang=js"

import "./PageTopImage.vue?vue&type=style&index=0&id=6a0358a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0358a8"]])

export default __exports__